import { handleActions } from 'redux-actions'
import { Immutable as ImmutableGenericsType } from 'seamless-immutable'
import get from 'lodash/get'

import { initialState, ModalDialogState } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils/redux'

const actionsNames = ['showModalDialog', 'hideModalDialog', 'hideAllModalDialogs']

interface Actions {
  showModalDialog: any
  hideModalDialog: any
  hideAllModalDialogs: any
}

export const actions: Actions = prepareActions(actionsNames, 'modal_dialog') as Actions

type State = ImmutableGenericsType<ModalDialogState>

export default handleActions<State, Payload>(
  {
    [actions.showModalDialog]: (state, action): State => {
      const modalId = get(action, 'payload.id') || get(action, 'id')
      const config: any = {
        ...action.payload,
        show: true,
        id: modalId,
      }

      // Don't show central error modals more times at a time
      if (state[modalId] && state[modalId].show) {
        return state
      }

      return state.setIn([modalId], config)
    },
    [actions.hideModalDialog]: (state, action): State => {
      if (action.payload) {
        const modalId = action.payload.toString()

        return state.without(modalId)
      }
      return state
    },
    [actions.hideAllModalDialogs]: (state): State => {
      const keys = Object.keys(state)

      let newState: any = state
      keys.forEach((key: string) => {
        newState = newState.without(key)
      })

      return newState
    },
  },
  initialState
)
